/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
jQuery(document).on('click','.special_add_to_cart a',function(){
  var obj=$(this);
 
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: $(this).attr("var_id")
    },
    dataType: 'json', 
    success: function (data) { 
      	  
          jQuery('.alert-add-to-cart-popup').remove();
          jQuery('body').append('<div class="alert-add-to-cart-popup"><div class="alert-add-to-cart-popup-inner">Your product has added to the cart</br><span id="ContinueBrowsing">Continue browsing</span> or <a href="/cart">View your cart</a> <svg class="Icon Icon--select-arrow-right" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></div>');
      	  //setTimeout(function(){ jQuery('.alert-add-to-cart-popup').remove(); }, 3500);
      	  var carticon = jQuery('.Header__CartDot'); 
      	  var cartnum = carticon.text();
      	  carticon.html((parseInt(cartnum) + 1));
      	  if(!carticon.hasClass('is-visible')) {
            carticon.addClass('is-visible');
          }
          jQuery('#ContinueBrowsing').click(function() {
            jQuery('.alert-add-to-cart-popup').remove();
          });
    } 
  });
});

jQuery('#shopify-section-featured-collections .Grid__Cell:nth-child(1)').wrap( "<div class='special-masonry'></div>" );
jQuery('.Footer__Block').wrap( "<div class='special-col-footer'></div>" );
jQuery('#shopify-section-featured-collections .Grid__Cell:nth-child(2), #shopify-section-featured-collections .Grid__Cell:nth-child(3)').wrapAll( "<div class='special-masonry'>" );
jQuery('.Footer__Block.Footer__Block--newsletter input.Form__Input, .Footer__Block.Footer__Block--newsletter button.Form__Submit.Button.Button--primary').wrapAll( "<div class='special-footer-newsletter'>" );

$(document).ready(function() {
	$('#shopify-section-cart-template').on('click', '[name="checkout"]', function() {
		if ($('#shopify-section-cart-template #agree').is(':checked')) {
        $(this).submit();
      }
	else {
        alert("You must agree with  TERMS & CONDITIONS.");
        return false;
      }
	});
});
